import { useDrop as useReactDndDrop } from 'react-dnd';
import { type DropTargetMonitor as ReactDndDropTargetMonitor } from 'react-dnd';

import type {
  Accept,
  DraggableItem,
  DraggableItemType,
  DropResult,
} from '../types';

type DropTargetMonitor<MonitorItem extends DraggableItem = DraggableItem> =
  ReactDndDropTargetMonitor<MonitorItem | null, DropResult>;

export type UseDropParam<
  AcceptedItemType extends DraggableItemType,
  CollectedProps,
  Item extends DraggableItem = DraggableItem<AcceptedItemType>,
> = {
  accept: Accept<AcceptedItemType>;
  canDrop?: (item: Item, monitor: DropTargetMonitor<Item>) => boolean;
  collect?: (monitor: DropTargetMonitor) => CollectedProps;
  onDropEnd?: (
    item: Item,
    monitor: DropTargetMonitor<Item>,
  ) => DropResult | undefined;
  onHover?: (item: Item, monitor: DropTargetMonitor<Item>) => void;
};

export const useDrop = <
  AcceptedItemType extends DraggableItemType,
  CollectedProps = unknown,
>({
  accept,
  canDrop,
  collect,
  onDropEnd,
  onHover,
}: UseDropParam<AcceptedItemType, CollectedProps>) =>
  useReactDndDrop(
    () => ({ accept, canDrop, collect, drop: onDropEnd, hover: onHover }),
    [accept, canDrop, collect, onDropEnd, onHover],
  );
